import React, { useEffect, useState, useMemo, useRef } from "react";
import { Link, useLocation } from "react-router";
import { MenuItem } from "react-pro-sidebar";

import { param } from "@/utils/param";
import { CutomerCare, menuItems } from "@/data/menuData";
import { GiStarSattelites } from "react-icons/gi";
import elite_logo from "./../../../../public/assets/images/elite_logo.png";
import { Row, Col } from "react-bootstrap";
import { trackButtonClick } from "@/utils/analytics";
import Cookies from "js-cookie";
import { store } from "@/store/store";
import "./UserDropDown.css";

const UserDropDown = ({ user, userType, tag, onSignOut }) => {
  const { pathname } = useLocation();

  const state = store.getState();
  const userID = state?.user?.user?.realbidUserId;

  const [menuData, setMenuData] = useState([]);
  const [selectedSellerName, setSelectedSellerName] = useState("");
  const [selectedSellerId, setSelectedSellerId] = useState(null);
  const [disableLink, setDisableLink] = useState("");
  const [sellerSearchQuery, setSellerSearchQuery] = useState("");
  const searchInputRef = useRef(null);

  const userName = user?.userFirstName + " " + user?.userLastName;

  // Search bar + seller IDs are only for PRIM_AUTH_USER
  const isPrimAuthUser = userType === "PRIM_AUTH_USER";

  // Check if there are associated sellers in the menu (search only shown for PRIM_AUTH_USER)
  const hasAssociatedSellers = useMemo(
    () =>
      isPrimAuthUser &&
      menuData.some((item) => item.name === "Seller" && item.subName),
    [menuData, isPrimAuthUser]
  );

  // Filter menu data based on search query (only filters seller items by name or ID)
  const filteredMenuData = useMemo(() => {
    if (!sellerSearchQuery.trim()) return menuData;
    const query = sellerSearchQuery.toLowerCase();
    return menuData.filter((item) => {
      // Non-seller items always show
      if (item.name !== "Seller" || !item.subName) return true;
      // Match against seller name or seller ID
      const nameMatch = item.subName.toLowerCase().includes(query);
      const idMatch = item.sellerId
        ? String(item.sellerId).toLowerCase().includes(query)
        : false;
      return nameMatch || idMatch;
    });
  }, [menuData, sellerSearchQuery]);

  // Reset search when menu data changes
  useEffect(() => {
    setSellerSearchQuery("");
  }, [menuData]);

  const addDefaultItems = () => {
    let itemsToAdd = [...menuItems];

  if (user.isElite === "T" || user.isElite === "Y"|| user.isElite === true) {
      itemsToAdd.splice(0, 0, {
        name: userName,
        routerPath: "",
      });
    }

    if (user?.userStatus === "PROFILE") {
      // Remove purchase profile by matching the routerPath
      itemsToAdd = itemsToAdd.filter(
        (item) => item.routerPath !== "/my-shopper/purchaseProfile"
      );
    }

    if (user.isCfdBuyer) {
      itemsToAdd.splice(4, 0, {
        name: "Cash For Deed",
        routerPath: "/my-shopper/cash-for-deed",
      });
    }
    //srpEnabled condition yet to implement
    itemsToAdd.push({
      name: "Account Settings",
      routerPath: "/my-shopper/accountSettings",
    });
    return itemsToAdd;
  };
  useEffect(() => {
    setMenuData([]);
  }, [userType]);

  const sellerUserRole = () => {
    if (
      user.smallSellerUserRole == "AUTH_USER" ||
      user.smallSellerUserRole == "AGENT" ||
      user.smallSellerUserRole == "PRIM_AUTH_USER"
    ) {
      setSelectedSellerName("Signature Seller Dashboard");
    }
  };
  const handleAssociateSellerAuth = () => {
    try {
      // Retrieve the sellerId from the URL query parameters
      const selectedSellerIdFromParam = param("sellerId");

      // Initialize local variables for selected seller and associated sellers
      let currentSelectedSellerId = selectedSellerIdFromParam || user.SellerId;
      let currentSelectedSellerName = selectedSellerIdFromParam
        ? "" // we'll fill this below if a match is found
        : user.sellerName;
      let linkDisabled = false;

      // If the sellerId is present in the URL, attempt to match it with associated sellers
      if (selectedSellerIdFromParam) {
        const associatedSellersList = user.associatedSellers
          ? user.associatedSellers.split("|")
          : [];

        associatedSellersList.forEach((seller) => {
          const [associatedSellerId, associatedSellerName] = seller.split("-");

          // Match the sellerId from the URL with the associated sellers
          if (currentSelectedSellerId === associatedSellerId) {
            currentSelectedSellerName = associatedSellerName;
            linkDisabled = true; // Disable link if matched
          }
        });
      }

      // Check if we're on the "my-seller" page and disable the link if necessary
      const location = window.location
        .toString()
        .split("?")[0]
        .split("#")[0]
        .split("/")
        .pop();
      if (location.match("my-seller")) {
        linkDisabled = true;
      }

      // Set the nameValue if we have a valid selectedSellerName
      if (currentSelectedSellerName) {
        nameValue = `Logged in as : Seller ${currentSelectedSellerName}`;
      }

      // Update state with the computed values
      setSelectedSellerId(currentSelectedSellerId);
      setSelectedSellerName(currentSelectedSellerName);
      setDisableLink(linkDisabled ? "Y" : "");
    } catch (error) {
      console.error("Error in associatedSellerAuth:", error);
    }
  };
  const mapAssociateSellerData = () => {
    const associatedSellers = user.associatedSellers;
    const sellers = associatedSellers ? associatedSellers.split("|") : [];

    if (sellers.length > 0) {
      const updatedMenuData = sellers.map((seller) => {
        const [sellerId, sellerName] = seller.split("-");
        const isDisabled = selectedSellerId === sellerId && disableLink === "Y";
        const routerPath = isDisabled
          ? "#"
          : `/sellerAdmin/my-seller?sellerId=${sellerId}`;

        return {
          name: "Seller",
          subName: sellerName,
          sellerId,
          routerPath,
          disabled: isDisabled,
        };
      });
      setMenuData((prevMenuData) => [...prevMenuData, ...updatedMenuData]);
      //setMenuData(updatedMenuData);
      if (userType === "PRIM_AUTH_USER" || userType === "AGENT") {
        sellerUserRole();
      }
    }
    // else {
    //   //handleNoAssociatedSellers();
    // }
  };

  const handleNoAssociatedSellers = () => {
    const updatedMenuData = [];
    if (user.mirrorUserFlag === "Y" && user.buddyMirrorFlag === "N") {
      updatedMenuData.push(...CutomerCare, {
        name: "Shopper Dashboard",
        routerPath: "/my-shopper/myProfile",
      });
    } else {
      updatedMenuData.push({ name: "Seller", routerPath: "/portal/my-seller" });
    }
    setMenuData((prevMenuData) => [...prevMenuData, ...updatedMenuData]);
    sellerUserRole();
  };
  const mapAssociatedSellersDataBuddyMirror = () => {
    setSelectedSellerName(`You are mirroring ${user.userFirstName}`);

    const associatedSellers = user.associatedSellers || "";
    const sellers = associatedSellers.split("|");

    if (sellers.length > 0) {
      let mirrorUserSeller1 = "";
      let mirrorUserSeller2 = "";

      const updatedMenuData = sellers.map((seller) => {
        const [sellerId, sellerName] = seller.split("-");
        if (sellerId === selectedSellerId) {
          mirrorUserSeller1 = sellerName;
          mirrorUserSeller2 = sellerId;
        }

        return {
          name: `Seller (${sellerName})`,
          routerPath: `/portal/my-seller?removeBuddyMirroring=Y&sellerId=${sellerId}`,
        };
      });

      updatedMenuData.push({
        name: `${user.userFirstName} Seller (${mirrorUserSeller1})`,
        routerPath: `/portal/my-seller?sellerId=${mirrorUserSeller2}`,
      });

      setMenuData((prevMenuData) => [...prevMenuData, ...updatedMenuData]);
    }
  };

  useEffect(() => {
    setMenuData([]); // Clear existing menu data first
    switch (userType) {
      case "AGENT":
        if (user.mirrorUserFlag === "Y") {
          // if (window.userSession.user.agentOnly != 'Y') {
          //     globalParam.config.isListingAgent = true;
          // }
          if (user.buddyMirrorFlag === "Y") {
            setSelectedSellerName(`You are mirroring ${user.userFirstName}`);
            setMenuData([
              {
                name: `My Account`,
                routerPath: "/my-shopper/myProfile?removeBuddyMirroring=Y",
              },
              {
                name: `Seller`,
                routerPath: "/portal/my-seller?removeBuddyMirroring=Y",
              },
              // {
              //   name: `${user.userFirstName} Seller Dashboard`,
              //   routerPath: "/portal/my-seller",
              // },
              {
                name: `${user.userFirstName} Shopper Dashboard`,
                routerPath: "/my-shopper/myProfile",
              },
            ]);
          } else {
            setSelectedSellerName(`You are mirroring ${user.userFirstName}`);
            setMenuData([
              ...CutomerCare,
              // {
              //   name: `${user.userFirstName} Seller Dashboard`,
              //   routerPath: "/portal/my-seller",
              // },
              {
                name: `${user.userFirstName} Shopper Dashboard`,
                routerPath: "/my-shopper/myProfile",
              },
            ]);

            mapAssociateSellerData();
          }
        } else if (user.agentOnly === "Y") {
          setMenuData(addDefaultItems());
          //preference buyer condition left to implement
        } else {
          if (user.internalUser === "Y") {
            setMenuData([
              { name: "My 'profile", routerPath: "/my-shopper/myProfile" },
              {
                name: "Change Password",
                routerPath: "/my-shopper/accountSettings",
              },
            ]);
          } else {
            setMenuData(addDefaultItems());
          }
          mapAssociateSellerData();
        }
        break;
      case "BUYR":
        if (user.mirrorUserFlag === "Y") {
          setSelectedSellerName(`You are mirroring ${user.userFirstName}`);
          setMenuData([
            ...CutomerCare,
            // {
            //   name: `${user.userFirstName} Seller Dashboard`,
            //   routerPath: "/portal/my-seller",
            // },
            {
              name: `${user.userFirstName} Shopper Dashboard`,
              routerPath: "/my-shopper/myProfile",
            },
          ]);
          sellerUserRole();
        } else {
          setMenuData(addDefaultItems());
          //preference user enabled logic pending
          sellerUserRole();
        }
        break;
      case "PRIM_AUTH_USER":
        handleAssociateSellerAuth();
        if (user.mirrorUserFlag === "Y") {
          if (user.buddyMirrorFlag === "Y") {
            mapAssociatedSellersDataBuddyMirror();
          } else {
            setSelectedSellerName(`You are mirroring ${user.userFirstName}`);
            mapAssociateSellerData();
          }
        } else {
          mapAssociateSellerData();
        }
        break;
      case "AUTH_USER":
        handleAssociateSellerAuth();
        if (user.mirrorUserFlag === "Y") {
          if (user.buddyMirrorFlag === "Y") {
            mapAssociatedSellersDataBuddyMirror();
          } else {
            setSelectedSellerName(`You are mirroring ${user.userFirstName}`);
            mapAssociateSellerData();
          }
        } else {
          mapAssociateSellerData();
        }
        break;
      case "CUST_CARE":
        setMenuData(CutomerCare);
        break;
      default:
    }
  }, [user, userType]);

  const MenuLink = ({ item, pathname }) => {
    const isActive = () => {
      let activeClass = undefined;

      if (item.name === "Seller") {
        const queryParams = new URLSearchParams(window.location.search);
        const currentSellerId = queryParams.get("sellerId");
        const routerSellerId = new URLSearchParams(
          item.routerPath.split("?")[1]
        ).get("sellerId");
        if (currentSellerId === routerSellerId) {
          activeClass = "ui-active";
        }
      } else {
        if (pathname.split("/")[1] === item.routerPath.split("/")[1]) {
          activeClass = "ui-active";
        }
      }

      return activeClass;
    };

    const isExternalRoute =
      item &&
      item.routerPath !== undefined &&
      (item.routerPath.startsWith("/portal") ||
        item.routerPath.startsWith("/sellerAdmin"));

    return item?.name === userName ? (
      <Col
        id="user-dropdown-elite-name"
        style={{
          fontWeight: "bold",
          color: "black",
          fontFamily: "graphikregular",
        }}
      >
        {item.name === userName && (
          <img id="user-dropdown-elite-logo" src={elite_logo} width={50} height={50} />
        )}
        {" " + item.name}
      </Col>
    ) : isExternalRoute ? (
      <a id={`user-dropdown-link-${item.routerPath.split('/').pop().split('?')[0]}`} href={item.routerPath} className={isActive()}>
        <span className="user-dropdown-seller-label">
          {item.name}
          {isPrimAuthUser && item.sellerId && (
            <span className="user-dropdown-seller-id">#{item.sellerId}</span>
          )}
        </span>
        <p className="m-0 user-dropdown-seller-name-text">{item.subName}</p>
      </a>
    ) : (
      <Link id={`user-dropdown-link-${item.routerPath.split('/').pop()}`} to={item.routerPath} className={isActive()}>
        <span className="user-dropdown-seller-label">
          {item.name}
          {isPrimAuthUser && item.sellerId && (
            <span className="user-dropdown-seller-id">#{item.sellerId}</span>
          )}
        </span>
        <p className="m-0 user-dropdown-seller-name-text">{item.subName}</p>
      </Link>
    );
  };

  return (
    <>
      {tag === "menu" ? (
        <>
          {selectedSellerName && (
            <MenuItem
              id="user-dropdown-menu-seller-name"
              component={
                <a
                  id="user-dropdown-seller-link"
                  href={
                    selectedSellerName === "Signature Seller Dashboard"
                      ? "/sell-a-home-in-an-online-auction/seller/myProfile"
                      : "#"
                  }
                  onClick={() => {
                    trackButtonClick({
                      eventName: "mobile_nav_click",
                      eventCategory: "Mobile Navigation",
                      eventSource: "Mobile Menu Click",
                      eventParams: { nav_item: selectedSellerName },
                    });
                  }}
                />
              }
            >
              {selectedSellerName}
            </MenuItem>
          )}
          {filteredMenuData.map((item, index) => (
            <MenuItem
              id={`user-dropdown-menu-item-${index}`}
              key={item.id || index}
              component={
                item.routerPath?.startsWith("/portal") ? (
                  <a
                    href={item.routerPath}
                    onClick={() => {
                      trackButtonClick({
                        eventName: "mobile_nav_click",
                        eventCategory: "Mobile Navigation",
                        eventSource: "Mobile Menu Click",
                        eventParams: { nav_item: item.name },
                      });
                    }}
                  />
                ) : (
                  <Link
                    to={item.routerPath || "#"}
                    onClick={() => {
                      trackButtonClick({
                        eventName: "mobile_nav_click",
                        eventCategory: "Mobile Navigation",
                        eventSource: "Mobile Menu Click",
                        eventParams: { nav_item: item.name },
                      });
                    }}
                  />
                )
              }
            >
              <span className="user-dropdown-seller-label">
                {item.name}
                {isPrimAuthUser && item.sellerId && (
                  <span className="user-dropdown-seller-id">#{item.sellerId}</span>
                )}
              </span>
              {item.subName && <p className="m-0 user-dropdown-seller-name-text">{item.subName}</p>}
            </MenuItem>
          ))}
          {hasAssociatedSellers && sellerSearchQuery && filteredMenuData.filter(i => i.name === "Seller" && i.subName).length === 0 && (
            <li className="user-dropdown-no-results">No sellers found</li>
          )}
          {hasAssociatedSellers && (
            <li className="user-dropdown-bottom-sticky">
              <div className={`user-dropdown-search-wrapper${sellerSearchQuery ? " has-value" : ""}`}>
                <input
                  ref={searchInputRef}
                  id="user-dropdown-seller-search-mobile"
                  type="text"
                  className="user-dropdown-search-input"
                  placeholder="Search by name or ID..."
                  value={sellerSearchQuery}
                  onChange={(e) => setSellerSearchQuery(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  autoComplete="off"
                />
                {sellerSearchQuery && (
                  <button
                    className="user-dropdown-search-clear"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSellerSearchQuery("");
                      searchInputRef.current?.focus();
                    }}
                    aria-label="Clear search"
                  >
                    &times;
                  </button>
                )}
              </div>
            </li>
          )}
        </>
      ) : (
        <>
          {selectedSellerName && (
            <li id="user-dropdown-seller-name">
              <a
                id="user-dropdown-seller-link-desktop"
                href={
                  selectedSellerName === "Signature Seller Dashboard"
                    ? "/sell-a-home-in-an-online-auction/seller/myProfile"
                    : "#"
                }
                onClick={() => {
                  trackButtonClick({
                    eventName:
                      tag === "menu" ? "mobile_nav_click" : "dropdown_menu_click",
                    eventCategory:
                      tag === "menu"
                        ? "Mobile Navigation"
                        : `${selectedSellerName} Click`,
                    eventSource:
                      tag === "menu"
                        ? "Mobile Menu Click"
                        : "Dropdown menu click",
                    eventParams: { menu_item: selectedSellerName },
                  });
                }}
              >
                {selectedSellerName}
              </a>
            </li>
          )}
          {filteredMenuData.map((item, index) => (
            <li
              id={`user-dropdown-item-${index}`}
              key={item.id || index}
              onClick={() => {
                trackButtonClick({
                  eventName:
                    tag === "menu" ? "mobile_nav_click" : "dropdown_menu_click",
                  eventCategory:
                    tag === "menu" ? "Mobile Navigation" : `${item.name} Click`,
                  eventSource:
                    tag === "menu"
                      ? "Mobile Menu Click"
                      : "Dropdown menu click",
                  eventParams: { menu_item: item.name },
                });
              }}
            >
              <MenuLink item={item} pathname={pathname} />
            </li>
          ))}
          {hasAssociatedSellers && sellerSearchQuery && filteredMenuData.filter(i => i.name === "Seller" && i.subName).length === 0 && (
            <li className="user-dropdown-no-results">No sellers found</li>
          )}
          {hasAssociatedSellers && (
            <li className="user-dropdown-bottom-sticky">
              <div className={`user-dropdown-search-wrapper${sellerSearchQuery ? " has-value" : ""}`}>
                <input
                  ref={searchInputRef}
                  id="user-dropdown-seller-search-desktop"
                  type="text"
                  className="user-dropdown-search-input"
                  placeholder="Search by name or ID..."
                  value={sellerSearchQuery}
                  onChange={(e) => setSellerSearchQuery(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  autoComplete="off"
                />
                {sellerSearchQuery && (
                  <button
                    className="user-dropdown-search-clear"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSellerSearchQuery("");
                      searchInputRef.current?.focus();
                    }}
                    aria-label="Clear search"
                  >
                    &times;
                  </button>
                )}
              </div>
              {onSignOut && (
                <div className="user-dropdown-signout-row" onClick={onSignOut}>
                  <Link id="header-signout-link">Sign Out</Link>
                </div>
              )}
            </li>
          )}
          {!hasAssociatedSellers && onSignOut && (
            <li className="signout" onClick={onSignOut}>
              <Link id="header-signout-link">Sign Out</Link>
            </li>
          )}
        </>
      )}
    </>
  );
};

export default UserDropDown;
